<template>
    <div name="use">
        <!-- 수집및 이용 동의 -->
        <h2>[유전자검사] 개인정보 수집 및 이용 동의</h2>
        솔닥 주식회사(이하 "회사“)는 업무 위탁 계약에 따라 병원 및 의원의 업무 중 일부를 대행하며, 개인정보처리자인 각 병원 및 의원의 개인정보 수집ㆍ이용ㆍ보유와 관련한 환경을 제공하고, 수집한 정보주체의 개인정보를 보관합니다.
        유전자검사 서비스 이용과 관련하여 본인의 개인정보를 수집 이용하고자 하는 경우에는 ⌜개인정보보호법⌟ 등 관계 법령에 따라 본인의 동의가 필요합니다.

        <table border="1" style="margin-top: 12px;">
            <thead>
                <tr>
                    <th>구분</th>
                    <th>수집 및 이용 목적</th>
                    <th>수집 항목</th>
                    <th>보유 및 이용 기간</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>유전자검사 서비스</td>
                    <td> - 병원 진료 서비스 제공(유전자검사 신청 의뢰, 진료내역 확인 및 관리, 상담) <br>
                        - 유전자검사 서비스 운영 및 관리</td>
                    <td>사용자식별값, (유전자검사 신청자의) 이름, 주소, 휴대폰번호, 생년월일, 성별, 키, 몸무게, 흡연유무</td>
                    <td>개인정보 처리방침에 따라 서비스 회원 탈퇴 및 이용계약 종료 시 또는 유전자검사 서비스 종료[1*] 시</td>
                </tr>
            </tbody>
        </table><br>

        [1*] 위 보유 기간에서의 유전자검사 서비스 종료일이란 "유전자 분석서비스 동의 해지를 하였거나, 서비스 이용이 종료된 날"을 말합니다. 유전자검사 서비스 종료일 후에는 관련 민원 처리, 법령상 의무이행을 위한 목적으로만 보유 이용됩니다.<br><br>
        ※ 이용자는 개인정보의 수집 및 이용 동의를 거부할 권리가 있습니다. 다만 동의 거부 시 해당 서비스를 이용하실 수 없습니다.

    </div>
</template>

<script>
export default {
    name: 'use'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/genetic/Use.vue